<!--
 * @Description: 系统参数页面
 * @Author: gaohc
 * @Date: 2023-12-18 16:43:52
-->
<template>
  <div class="body-sys-param">
    <div class="section">
      <div class="section-title">支付平台配置</div>
      <div class="section-content">
        <el-checkbox-group disabled v-model="paymentPlatformFilter" :min="0" :max="1" style="display: inline-block">
          <el-checkbox v-for="(value, key) in paymentPlatformMap" :key="parseInt(key)" :label="parseInt(key)"
            :disabled="updateDisable" >
            {{value}}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="section" style="margin-top: 5px;">
      <div class="section-title" style="margin-bottom: 15px;">系统资源配置</div>
      <div class="section-content sys-param-style" v-for="(item, index) in sysParamList" :key="index">
        <el-checkbox v-model="item.checked" :true-label="1" :false-label="0" :disabled="updateDisable" 
          @change="changePrivacyNumStatus(index)">
          {{'启用' + item.name}}
        </el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: 'SysParam',

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      systemParamCfgDTO: {},
      paymentPlatformMap: {},
      paymentPlatformFilter: [0],
      sysParamList: [
        {name: '短信', checked: 0},
        {name: '实名认证', checked: 0},
        {name: '一键登录', checked: 0},
      ],
      newSysParamList: [],
      paramsObj: {},
    }
  },

  computed: {
    updateDisable() {
      return !this.dataPvgList.includes('SYSCFG_1_UPDATE');
    },
  },

  methods: {
    async initData() {
      await this.getDataPvg4CurRole();
      await this.getParamDo();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'SYSCFG'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    getParamDo() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_SYSTEM_PARAM_DO,
        }; 
        this.vueRequest(requestData).then(result => {
          if (result == null) {
            return;
          }
          this.paymentPlatformMap = result.data.paymentPlatformMap;
          this.paymentPlatformFilter = [result.data.systemParamCfg.paymentPlatform];
          this.systemParamCfgDTO = result.data.systemParamCfg;
          this.rebuildData();
          resolve();
        })
      })
    },

    rebuildData() {
      this.sysParamList[0].checked = this.systemParamCfgDTO.useSms;
      this.sysParamList[1].checked = this.systemParamCfgDTO.useRealname;
      this.sysParamList[2].checked = this.systemParamCfgDTO.useUnilogin;
      this.newSysParamList = Array.from(this.sysParamList, obj => ({ ...obj }));
    },

    changePrivacyNumStatus(index) {
      this.paramsObj = {};
      this.sysParamList[index].checked = this.newSysParamList[index].checked;
      let configs = {
        0: {key: 'useSms', titleState: this.systemParamCfgDTO.useSms},
        1: {key: 'useRealname', titleState: this.systemParamCfgDTO.useRealname},
        2: {key: 'useUnilogin', titleState: this.systemParamCfgDTO.useUnilogin}
      };
      let config = configs[index];
      let actionText = config.titleState == 0 ? '启用' : '禁用';
      let content = `确认是否${actionText}`;
      this.$confirm(content, `${actionText}${this.sysParamList[index].name}`, {
        confirmButtonText: actionText,
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getSaveData();
        if (index == 0) {
          this.$set(this.paramsObj, 'useSms', this.systemParamCfgDTO.useSms == 1 ? 0 : 1);
        } else if (index == 1) {
          this.$set(this.paramsObj, 'useRealname', this.systemParamCfgDTO.useRealname == 1 ? 0 : 1);
        } else if (index == 2) {
          this.$set(this.paramsObj, 'useUnilogin', this.systemParamCfgDTO.useUnilogin == 1 ? 0 : 1);
        }
        this.updateSystemParam();
      }).catch((err) => {
        console.log('err---',err);
      });
    },

    getSaveData() {
      this.$set(this.paramsObj, 'useSms', this.systemParamCfgDTO.useSms);
      this.$set(this.paramsObj, 'useRealname', this.systemParamCfgDTO.useRealname);
      this.$set(this.paramsObj, 'useUnilogin', this.systemParamCfgDTO.useUnilogin);
    },

    updateSystemParam() {
      let systemParamCfgDTO = {'id': this.systemParamCfgDTO.id};
      let params = {...systemParamCfgDTO, ...this.paramsObj};
      let header = this.encryptionUtil.signatureBody(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT',
        url: Constant.URL_UPDATE_SYSTEM_PARAM,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.$message({type: 'success', message: '修改成功!',});
          this.getParamDo();
        }
      });
    }
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '系统配置', text2: '系统参数'});
    this.initData();
  }
}
</script>

<style scoped>
.body-sys-param {
  margin: 0 40px;
  text-align: left;
  border: solid 0px;
}
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #343434;
  line-height: 22px;
}
.section-content {
  margin: 25px 0 25px 64px;
}
</style>


// WEBPACK FOOTER //
// src/components/syscfg/SysParam.vue